import { Observable, map } from 'rxjs';

import { NewsletterFeaturePublicApi } from '@features/newsletter/public.api';

export const feelJoinUseCase$ = (
    { storeId, languageId },
    feelSubscriptionApiRepository
): Observable<void> =>
    feelSubscriptionApiRepository.signUp(storeId, languageId).pipe(map(() => null));

export const feelJoinNewsletterUseCase$ = (
    storeAndLanguage,
    newsletterPublicApi: NewsletterFeaturePublicApi,
    newsletterSections: string[],
    email: string
): Observable<void> =>
    newsletterPublicApi.subscribeToNewsletter$(
        email,
        newsletterSections,
        { id: '7', value: 'web_alta_feel' },
        storeAndLanguage
    ).pipe(map(() => null));
